var render = function render(){var _vm=this,_c=_vm._self._c;return _c('validated-input',{attrs:{"id":'user-name-' + _vm._uid,"idGtm":"usuario","value":_vm.value,"validations":_vm.validations,"label":_vm.label,"quantumObfuscate":_vm.quantumObfuscate},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }